import React from 'react'

export const ClockIcon = () => {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20 10V20H27.5M35 20C35 21.9698 34.612 23.9204 33.8582 25.7403C33.1044 27.5601 31.9995 29.2137 30.6066 30.6066C29.2137 31.9995 27.5601 33.1044 25.7403 33.8582C23.9204 34.612 21.9698 35 20 35C18.0302 35 16.0796 34.612 14.2597 33.8582C12.4399 33.1044 10.7863 31.9995 9.3934 30.6066C8.00052 29.2137 6.89563 27.5601 6.14181 25.7403C5.38799 23.9204 5 21.9698 5 20C5 16.0218 6.58035 12.2064 9.3934 9.3934C12.2064 6.58035 16.0218 5 20 5C23.9782 5 27.7936 6.58035 30.6066 9.3934C33.4196 12.2064 35 16.0218 35 20Z"
        stroke="#08467C"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export const QuestionsIcon = () => {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.6667 23.3333C8.90524 23.3333 6.66666 25.5718 6.66666 28.3333C6.66666 31.0948 8.90524 33.3333 11.6667 33.3333C12.2511 33.3333 12.812 33.233 13.3333 33.0488"
        stroke="#08467C"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.10654 26.0077C4.87384 24.9303 3.3334 22.645 3.3334 20C3.3334 17.9805 4.23129 16.1709 5.64964 14.9483"
        stroke="#08467C"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.70088 14.8137C5.25817 14.1518 5 13.356 5 12.5C5 10.1988 6.86548 8.33333 9.16667 8.33333C10.1049 8.33333 10.9706 8.64339 11.6671 9.16666"
        stroke="#08467C"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.0628 9.27554C11.8087 8.73691 11.6667 8.13504 11.6667 7.49999C11.6667 5.19881 13.5321 3.33333 15.8333 3.33333C18.1345 3.33333 20 5.19881 20 7.49999V33.3333"
        stroke="#08467C"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.3333 33.3333C13.3333 35.1743 14.8257 36.6667 16.6667 36.6667C18.5077 36.6667 20 35.1743 20 33.3333"
        stroke="#08467C"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20 11.6667C20 14.4281 22.2385 16.6667 25 16.6667"
        stroke="#08467C"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M34.3503 14.9483C35.7687 16.1709 36.6667 17.9805 36.6667 20C36.6667 21.1718 36.3643 22.273 35.8333 23.2298"
        stroke="#08467C"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M34.2992 14.8137C34.7418 14.1518 35 13.356 35 12.5C35 10.1988 33.1345 8.33333 30.8333 8.33333C29.8952 8.33333 29.0293 8.64339 28.333 9.16666"
        stroke="#08467C"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20 7.5C20 5.19881 21.8655 3.33333 24.1667 3.33333C26.4678 3.33333 28.3333 5.19881 28.3333 7.5C28.3333 8.13505 28.1913 8.73691 27.9372 9.27555"
        stroke="#08467C"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M23.3333 36.6667C21.4923 36.6667 20 35.1743 20 33.3333"
        stroke="#08467C"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M34.1667 34.1667L36.6667 36.6667"
        stroke="#08467C"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M26.6667 30.8333C26.6667 33.1345 28.5322 35 30.8333 35C31.986 35 33.0292 34.532 33.7835 33.7757C34.5352 33.022 35 31.982 35 30.8333C35 28.5322 33.1345 26.6667 30.8333 26.6667C28.5322 26.6667 26.6667 28.5322 26.6667 30.8333Z"
        stroke="#08467C"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export const ExerciseIcon = ({ source, className }) => {
  const stroke =
    source === 'ExerciseSteps' || source === 'StartExercise'
      ? '#08467C'
      : 'white'
  const strokeWidth = '1.5'
  return (
    <svg
      className={className}
      width="75"
      height="75"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.33335 31.6667C12.0153 31.6667 15 28.6818 15 25C15 21.3182 12.0153 18.3333 8.33335 18.3333C4.65145 18.3333 1.66669 21.3182 1.66669 25C1.66669 28.6818 4.65145 31.6667 8.33335 31.6667Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.1667 12.5H24.1667M24.1667 12.5H25L31.6667 25M24.1667 12.5L27.5 7.5M27.5 7.5H23.3334M27.5 7.5H30.8334"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.33331 25L14.1666 12.5L20 23.3333H25"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.1666 12.5C13.6111 10.8333 11.6666 7.5 8.33331 7.5"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M31.6667 31.6667C35.3485 31.6667 38.3333 28.6818 38.3333 25C38.3333 21.3182 35.3485 18.3333 31.6667 18.3333C27.9848 18.3333 25 21.3182 25 25C25 28.6818 27.9848 31.6667 31.6667 31.6667Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export const ConclusionPageImage = () => {
  return (
    <svg
      width="158"
      height="157"
      viewBox="0 0 158 157"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M78.989 0C53.107 0 32.0537 21.0533 32.0537 46.9353C32.0463 53.5604 33.4492 60.1113 36.169 66.1524C43.5247 82.4784 59.9483 93.8705 78.989 93.8705C91.4349 93.8636 103.369 88.9165 112.17 80.1159C120.97 71.3153 125.917 59.3812 125.924 46.9353C125.924 21.0533 104.867 0 78.989 0ZM117.821 65.8032C114.277 73.0874 108.757 79.2289 101.891 83.5276C95.0254 87.8263 87.0896 90.1091 78.989 90.1157C60.6918 90.1157 45.0154 78.6748 38.7411 62.5704C36.7965 57.5873 35.8019 52.2843 35.8086 46.9353C35.8086 23.1259 55.1797 3.75483 78.989 3.75483C102.798 3.75483 122.169 23.1259 122.169 46.9353C122.178 53.4739 120.69 59.9277 117.821 65.8032Z"
        fill="#D8F0C8"
      />
      <path
        d="M78.9887 94.0098C70.0983 94.0026 61.3912 91.481 53.8728 86.7361C46.3545 81.9913 40.3314 75.2167 36.4992 67.1946C36.3462 66.8747 36.2798 66.5204 36.3066 66.1668C36.3333 65.8133 36.4523 65.4729 36.6517 65.1797L36.6769 65.1429C36.876 64.8544 37.1474 64.6235 37.464 64.4731C37.7806 64.3228 38.1312 64.2583 38.4805 64.2863C38.8299 64.3142 39.1657 64.4335 39.4544 64.6323C39.743 64.8311 39.9743 65.1023 40.125 65.4187C47.2458 80.3369 62.5007 89.9765 78.9886 89.9765C86.5234 89.9573 93.9222 87.9684 100.451 84.2072C106.98 80.446 112.412 75.0431 116.208 68.5346C116.385 68.2289 116.639 67.9754 116.945 67.7999C117.252 67.6243 117.599 67.533 117.952 67.5352C118.301 67.5343 118.644 67.6265 118.946 67.8024C119.248 67.9783 119.497 68.2315 119.668 68.5358L119.69 68.5743C119.864 68.8814 119.954 69.2287 119.953 69.5815C119.951 69.9344 119.857 70.2806 119.68 70.5859C115.526 77.6976 109.587 83.6003 102.449 87.709C95.3116 91.8177 87.2243 93.9897 78.9887 94.0098Z"
        fill="#35933B"
      />
      <path
        d="M68.4102 51.2282C69.6859 51.2199 70.925 51.6547 71.9158 52.4583C72.9067 53.2618 73.5879 54.3844 73.8433 55.6344C74.0986 56.8844 73.9121 58.1842 73.3158 59.312C72.7194 60.4398 71.7501 61.3256 70.5733 61.8183C69.3965 62.311 68.0852 62.3799 66.8632 62.0134C65.6412 61.6468 64.5843 60.8675 63.873 59.8085C63.1616 58.7495 62.8399 57.4764 62.9627 56.2065C63.0855 54.9367 63.6453 53.7488 64.5464 52.8458C65.0514 52.334 65.653 51.9275 66.3162 51.6499C66.9794 51.3722 67.6912 51.2289 68.4102 51.2282ZM68.4102 48.8814C66.8627 48.8806 65.3498 49.3386 64.0627 50.1976C62.7756 51.0567 61.7721 52.278 61.1792 53.7074C60.5863 55.1367 60.4305 56.7097 60.7316 58.2276C61.0326 59.7455 61.777 61.1399 62.8706 62.2347C63.9643 63.3295 65.358 64.0754 66.8755 64.3781C68.393 64.6808 69.9662 64.5267 71.3962 63.9353C72.8261 63.3439 74.0486 62.3418 74.909 61.0556C75.7694 59.7694 76.2291 58.257 76.2299 56.7095C76.231 54.6345 75.4078 52.644 73.9413 51.1759C72.4748 49.7079 70.4852 48.8825 68.4102 48.8814ZM84.7118 37.6924C85.4195 37.696 86.0997 37.4183 86.6027 36.9204C87.1056 36.4225 87.3902 35.7451 87.3938 35.0374C87.3939 35.0284 87.3939 35.0194 87.3938 35.0103C87.3971 34.6636 87.3321 34.3197 87.2025 33.9981C87.0729 33.6765 86.8812 33.3836 86.6384 33.1362C86.3956 32.8887 86.1064 32.6914 85.7873 32.5557C85.4683 32.42 85.1256 32.3484 84.7789 32.3451C84.7621 32.3449 84.7454 32.3449 84.7286 32.3451C84.0195 32.3384 83.3368 32.6137 82.8307 33.1103C82.3246 33.607 82.0365 34.2844 82.0298 34.9935C82.0231 35.7025 82.2984 36.3852 82.795 36.8914C83.2917 37.3975 83.9691 37.6856 84.6782 37.6923C84.6894 37.6924 84.7006 37.6924 84.7118 37.6924ZM90.3189 51.2282C91.5946 51.2199 92.8337 51.6546 93.8246 52.4582C94.8154 53.2618 95.4967 54.3844 95.752 55.6344C96.0073 56.8843 95.8209 58.1842 95.2245 59.312C94.6281 60.4398 93.6588 61.3256 92.482 61.8183C91.3052 62.311 89.9939 62.3799 88.7719 62.0134C87.5499 61.6468 86.4931 60.8675 85.7817 59.8085C85.0703 58.7495 84.7486 57.4764 84.8714 56.2065C84.9943 54.9367 85.554 53.7488 86.4551 52.8457C86.9602 52.334 87.5617 51.9275 88.2249 51.6498C88.8882 51.3722 89.5999 51.2289 90.3189 51.2282ZM90.3189 48.8814C88.7723 48.8814 87.2604 49.34 85.9745 50.1993C84.6885 51.0585 83.6862 52.2798 83.0944 53.7087C82.5025 55.1375 82.3477 56.7098 82.6494 58.2267C82.9511 59.7436 83.6959 61.1369 84.7895 62.2306C85.8831 63.3242 87.2765 64.0689 88.7933 64.3707C90.3102 64.6724 91.8825 64.5175 93.3114 63.9257C94.7403 63.3338 95.9615 62.3315 96.8208 61.0456C97.68 59.7596 98.1387 58.2478 98.1387 56.7012C98.1387 55.6742 97.9364 54.6574 97.5434 53.7087C97.1504 52.7599 96.5744 51.8979 95.8483 51.1718C95.1222 50.4456 94.2601 49.8696 93.3114 49.4766C92.3627 49.0837 91.3458 48.8814 90.3189 48.8814Z"
        fill="#35933B"
      />
      <path
        d="M88.7514 43.0732H84.7284L82.256 38.036C82.0565 37.6828 81.7777 37.3807 81.4417 37.1534C81.1056 36.9262 80.7215 36.78 80.3193 36.7264C79.9172 36.6727 79.5082 36.7131 79.1243 36.8444C78.7405 36.9757 78.3923 37.1942 78.1072 37.4828L72.0978 43.2743C71.6059 43.7764 71.3267 44.4489 71.3184 45.1517C71.3184 46.6101 72.3744 47.1297 72.8689 47.4231C76.6824 49.619 78.0234 49.862 78.0234 50.96V56.4832C78.0234 56.8389 78.1647 57.18 78.4162 57.4315C78.6677 57.683 79.0087 57.8242 79.3644 57.8242C79.7201 57.8242 80.0611 57.683 80.3126 57.4315C80.5641 57.18 80.7054 56.8389 80.7054 56.4832V48.9401C80.7054 47.8337 78.1575 46.9286 76.6572 45.7552L80.7557 41.4388C82.323 43.8275 83.0438 45.7552 83.9406 45.7552H88.7514C89.1071 45.7558 89.4484 45.615 89.7003 45.3639C89.9522 45.1129 90.094 44.772 90.0946 44.4163C90.0952 44.0607 89.9545 43.7194 89.7034 43.4675C89.4523 43.2156 89.1114 43.0737 88.7558 43.0732L88.7514 43.0732Z"
        fill="#35933B"
      />
      <path
        d="M41.2368 119.181C40.0816 119.181 39.1252 122.544 38.9398 126.954H16.7159C16.5306 122.544 15.5741 119.181 14.4189 119.181C13.131 119.181 12.0869 123.357 12.0869 128.509C12.0869 133.66 13.131 137.836 14.4189 137.836C15.5741 137.836 16.5306 134.473 16.7159 130.063H38.9398C39.1252 134.473 40.0816 137.836 41.2368 137.836C42.5247 137.836 43.5688 133.66 43.5688 128.509C43.5688 123.357 42.5247 119.181 41.2368 119.181Z"
        fill="#28B5EC"
      />
      <path
        d="M52.0618 114.736C48.7679 108.833 43.435 104.332 37.0616 102.077C30.6882 99.8222 23.7115 99.9677 17.4377 102.486C11.164 105.005 6.02335 109.724 2.97848 115.76C-0.0663954 121.796 -0.806745 128.735 0.896054 135.278C2.59885 141.82 6.62804 147.518 12.2292 151.303C17.8303 155.089 24.6193 156.703 31.3249 155.844C38.0305 154.985 44.193 151.71 48.6584 146.635C53.1238 141.559 55.586 135.029 55.5838 128.269C55.5823 123.531 54.37 118.873 52.0618 114.736ZM27.7831 153.843C21.0451 153.808 14.5957 151.103 9.8495 146.32C5.10328 141.537 2.44768 135.067 2.46511 128.329C2.48255 121.591 5.1716 115.135 9.9425 110.377C14.7134 105.618 21.1767 102.946 27.9148 102.947C34.653 102.947 41.1159 105.62 45.8862 110.379C50.6565 115.138 53.3447 121.594 53.3612 128.332C53.3778 135.071 50.7213 141.54 45.9745 146.323C41.2277 151.105 34.778 153.809 28.0399 153.843C27.9543 153.843 27.8687 153.843 27.7831 153.843Z"
        fill="#28B5EC"
        fillOpacity="0.21"
      />
      <path
        d="M27.7964 156.209C22.4993 156.211 17.311 154.705 12.839 151.866C12.6156 151.723 12.4433 151.514 12.3467 151.267L12.3327 151.231C12.2357 150.986 12.2197 150.717 12.2872 150.463C12.3547 150.209 12.5021 149.983 12.7077 149.819C12.9064 149.652 13.1535 149.553 13.4127 149.538C13.6718 149.522 13.9291 149.59 14.1467 149.731C18.9 152.757 24.5238 154.118 30.1345 153.6C35.7453 153.082 41.025 150.715 45.1444 146.871C49.2638 143.026 51.9893 137.922 52.8928 132.361C53.7963 126.799 52.8266 121.095 50.136 116.144C50.0098 115.917 49.96 115.656 49.9937 115.398C50.0274 115.141 50.143 114.901 50.3233 114.714C50.5014 114.52 50.7371 114.389 50.9956 114.339C51.2541 114.289 51.5217 114.324 51.759 114.438L51.7938 114.454C52.0319 114.566 52.2284 114.75 52.3551 114.98C54.6581 119.233 55.8172 124.012 55.7187 128.848C55.6202 133.683 54.2676 138.411 51.7933 142.567C49.3191 146.723 45.8079 150.165 41.6036 152.556C37.3994 154.948 32.6462 156.206 27.8094 156.209H27.7964Z"
        fill="#28B5EC"
      />
      <path
        d="M130.181 100.473C126.53 100.471 122.914 101.189 119.54 102.585C116.166 103.981 113.1 106.028 110.517 108.61C107.934 111.191 105.885 114.255 104.487 117.629C103.089 121.002 102.369 124.617 102.368 128.269C102.368 131.92 103.086 135.536 104.483 138.91C105.88 142.283 107.928 145.349 110.51 147.931C113.092 150.513 116.157 152.561 119.53 153.958C122.904 155.356 126.52 156.075 130.171 156.074H130.181C130.361 156.074 130.538 156.074 130.718 156.067C138.043 155.926 145.017 152.899 150.122 147.644C155.228 142.389 158.052 135.33 157.981 128.004C157.91 120.678 154.95 113.675 149.744 108.52C144.538 103.364 137.508 100.473 130.181 100.473ZM135.847 153.213C132.338 154.01 128.7 154.058 125.172 153.352C121.643 152.647 118.303 151.206 115.369 149.121C112.436 147.037 109.975 144.357 108.149 141.257C106.322 138.157 105.169 134.706 104.767 131.13C104.365 127.554 104.722 123.934 105.815 120.505C106.908 117.077 108.711 113.918 111.109 111.234C113.506 108.55 116.442 106.402 119.726 104.931C123.01 103.46 126.568 102.698 130.166 102.696H130.181C136.471 102.695 142.541 105.013 147.23 109.205C151.919 113.397 154.899 119.171 155.6 125.421C156.301 131.672 154.674 137.962 151.03 143.089C147.386 148.216 141.981 151.82 135.847 153.213Z"
        fill="#FDB618"
        fillOpacity="0.12"
      />
      <path
        d="M130.181 156.214C123.286 156.214 116.635 153.664 111.506 149.055C106.377 144.446 103.134 138.104 102.4 131.248C101.666 124.392 103.493 117.507 107.529 111.917C111.566 106.326 117.527 102.426 124.266 100.966C124.432 100.931 124.603 100.929 124.77 100.96L124.828 100.971C125.107 101.025 125.359 101.174 125.542 101.393C125.724 101.611 125.826 101.886 125.829 102.171C125.832 102.456 125.737 102.733 125.56 102.956C125.383 103.179 125.134 103.334 124.856 103.394C118.713 104.711 113.274 108.255 109.588 113.342C105.902 118.429 104.229 124.701 104.89 130.949C105.552 137.196 108.502 142.978 113.172 147.18C117.843 151.382 123.903 153.708 130.185 153.709C130.431 153.706 130.67 153.705 130.912 153.698C131.183 153.687 131.449 153.771 131.663 153.936C131.878 154.101 132.027 154.337 132.086 154.601C132.15 154.857 132.121 155.126 132.005 155.363C131.89 155.599 131.694 155.787 131.453 155.893C131.289 155.968 131.125 156.042 130.96 156.114C130.82 156.176 130.67 156.209 130.518 156.212C130.406 156.214 130.295 156.214 130.181 156.214Z"
        fill="#FDB618"
      />
      <path
        d="M143.896 127.092C143.156 127.055 142.423 127.261 141.811 127.679C141.198 128.097 140.739 128.704 140.504 129.407H137.766L135.767 123.397C135.693 123.171 135.55 122.975 135.358 122.836C135.166 122.697 134.934 122.623 134.697 122.622H134.676C134.436 122.626 134.203 122.708 134.012 122.855C133.822 123.002 133.685 123.207 133.621 123.439L130.489 134.369L126.808 112.262C126.765 112.006 126.635 111.773 126.441 111.601C126.247 111.43 125.999 111.33 125.74 111.319C125.481 111.309 125.226 111.387 125.018 111.542C124.81 111.697 124.661 111.919 124.598 112.171L120.867 129.407H116.687C116.388 129.407 116.102 129.526 115.89 129.737C115.679 129.948 115.561 130.235 115.561 130.533C115.561 130.832 115.679 131.118 115.89 131.33C116.102 131.541 116.388 131.66 116.687 131.66H121.754C122.005 131.66 122.249 131.576 122.446 131.422C122.644 131.267 122.785 131.051 122.845 130.808L125.477 117.984L129.088 139.655C129.129 139.907 129.256 140.138 129.447 140.308C129.638 140.479 129.881 140.578 130.137 140.591H130.2C130.445 140.591 130.683 140.511 130.878 140.364C131.074 140.216 131.216 140.01 131.284 139.774L134.782 127.556L135.887 130.885C135.962 131.11 136.106 131.305 136.298 131.444C136.489 131.583 136.72 131.658 136.957 131.66H140.553C140.768 132.229 141.133 132.73 141.609 133.109C142.085 133.488 142.655 133.732 143.258 133.814C143.861 133.896 144.475 133.814 145.036 133.576C145.596 133.338 146.081 132.953 146.441 132.462C146.801 131.97 147.021 131.391 147.078 130.785C147.136 130.179 147.028 129.569 146.768 129.019C146.507 128.469 146.103 127.999 145.597 127.66C145.092 127.321 144.504 127.125 143.896 127.092Z"
        fill="#FDB618"
      />
    </svg>
  )
}

export const PersonIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.75 6C15.75 6.99456 15.3549 7.94839 14.6516 8.65165C13.9484 9.35491 12.9945 9.75 12 9.75C11.0054 9.75 10.0516 9.35491 9.34833 8.65165C8.64506 7.94839 8.24998 6.99456 8.24998 6C8.24998 5.00544 8.64506 4.05161 9.34833 3.34835C10.0516 2.64509 11.0054 2.25 12 2.25C12.9945 2.25 13.9484 2.64509 14.6516 3.34835C15.3549 4.05161 15.75 5.00544 15.75 6ZM4.50098 20.118C4.53311 18.1504 5.33731 16.2742 6.74015 14.894C8.14299 13.5139 10.0321 12.7405 12 12.7405C13.9679 12.7405 15.857 13.5139 17.2598 14.894C18.6626 16.2742 19.4668 18.1504 19.499 20.118C17.1464 21.1968 14.5881 21.7535 12 21.75C9.32398 21.75 6.78398 21.166 4.50098 20.118Z"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export const CalendarIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.75 3V5.25M17.25 3V5.25M3 18.75V7.5C3 6.90326 3.23705 6.33097 3.65901 5.90901C4.08097 5.48705 4.65326 5.25 5.25 5.25H18.75C19.3467 5.25 19.919 5.48705 20.341 5.90901C20.7629 6.33097 21 6.90326 21 7.5V18.75M3 18.75C3 19.3467 3.23705 19.919 3.65901 20.341C4.08097 20.7629 4.65326 21 5.25 21H18.75C19.3467 21 19.919 20.7629 20.341 20.341C20.7629 19.919 21 19.3467 21 18.75M3 18.75V11.25C3 10.6533 3.23705 10.081 3.65901 9.65901C4.08097 9.23705 4.65326 9 5.25 9H18.75C19.3467 9 19.919 9.23705 20.341 9.65901C20.7629 10.081 21 10.6533 21 11.25V18.75M12 12.75H12.008V12.758H12V12.75ZM12 15H12.008V15.008H12V15ZM12 17.25H12.008V17.258H12V17.25ZM9.75 15H9.758V15.008H9.75V15ZM9.75 17.25H9.758V17.258H9.75V17.25ZM7.5 15H7.508V15.008H7.5V15ZM7.5 17.25H7.508V17.258H7.5V17.25ZM14.25 12.75H14.258V12.758H14.25V12.75ZM14.25 15H14.258V15.008H14.25V15ZM14.25 17.25H14.258V17.258H14.25V17.25ZM16.5 12.75H16.508V12.758H16.5V12.75ZM16.5 15H16.508V15.008H16.5V15Z"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
